import { axiosInstance } from "@/api";

export type CreatorOnboardingStep = "socials" | "profile" | "bank";
export type CreatorOnboardingStatus = "in_progress" | "completed";

export interface CreatorOnboardingProgress {
	userId: string;
	status: CreatorOnboardingStatus;
	currentStep: CreatorOnboardingStep;
	completedSteps: CreatorOnboardingStep[];
	startedAt: string;
	updatedAt: string;
	completedAt: string | null;
}

export interface CreatorOnboardingUpdate {
	currentStep: CreatorOnboardingStep;
	completedSteps: CreatorOnboardingStep[];
	status?: CreatorOnboardingStatus;
}

export const creatorOnboardingApi = {
	get: async (): Promise<CreatorOnboardingProgress | null> => {
		const response = await axiosInstance.get("/creators/me/onboarding");
		return response.data.progress ?? null;
	},
	start: async (): Promise<CreatorOnboardingProgress> => {
		const response = await axiosInstance.put("/creators/me/onboarding", { start: true });
		return response.data.progress;
	},
	update: async (update: CreatorOnboardingUpdate): Promise<CreatorOnboardingProgress> => {
		const response = await axiosInstance.put("/creators/me/onboarding", update);
		return response.data.progress;
	},
};
